module.exports = __webpack_public_path__ + "static/img/icon_szh_sdnl_fajc.7403fb82.png";